import { CdkScrollable } from '@angular/cdk/overlay';
import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoScrollable]',
})
export class XpoScrollableDirective extends CdkScrollable {}
